Pixlee.module('Behaviors', function(Behaviors, App, Backbone, Marionette, $) {

    Behaviors.Tap2ShopMobile = Marionette.Behavior.extend({
        ui: {
            customCtaAnchor: '.custom_call_to_action_anchor',
            layerVideo: '.layer_video'
        },
        events: {
            'click @ui.customCtaAnchor': 'ctaClicked',
            'click @ui.layerVideo': 'openVideoLightboxDebounced',
            'keydown @ui.layerVideo': 'openVideoLightboxDebounced'
        },
        initialize: function() {
            this.currentAlbum = App.currentAlbum;
            this.displayOptions = App.displayOptions;

            this.openVideoLightboxDebounced = _.debounce(this.openVideoLightbox, 300, true);
        },
        onShow: function() {
            var link = this.generateCtaLink();

            if (!_.isFalsy(link)) {
                var formattedLink = App.request('decode:utf8', this.formatLink(link, this.view.model));
                this.ui.customCtaAnchor.attr('href', formattedLink);

                if (this.view.model.get('content_type') === 'video') {
                    this.ui.layerVideo.attr('href', formattedLink);
                }
            }
        },
        ctaClicked: function() {
            var link = this.generateCtaLink();

            if (!_.isFalsy(link)) {
                App.execute('opened:photo', this.view.model.get('album_photo_id'), 1, link);
                App.execute('action:clicked', this.view.model.get('album_photo_id'), link);
            }
        },
        generateCtaLink: function() {
            var link = '';
            var model = this.view.model;

            if (this.currentAlbum.get('album_type') !== 'product' && model.get('action_link')) {
                link = model.get('action_link');
            } else if (model.get('products').length > 0) {
                link = model.get('products')[0].link;
            } else if (gon.display_options.customCallToActionLink) {
                link = gon.display_options.customCallToActionLink;
            }
            return link;
        },
        openVideoLightbox: function(ev) {
            // Keycode 13 = Enter Key
            if (ev.type === 'keydown' && ev.keyCode !== 13) {
                return;
            }

            ev.preventDefault();
            var obj = {
                sortType: gon.sortType,
                widget: gon.widget
            };

            var videos = this.view.model.collection.clone();
            var currModel;

            // we only want them to go through videos in lightbox
            for (var i = videos.length - 1; i >= 0; i--) {
                currModel = videos.models[i];
                if (currModel.get('content_type') !== 'video') {
                    videos.models.splice(i, 1);
                }
            }

            var message = {
                name: 'pixlee:open:lightbox',
                type: 'action',
                source: 'widget',
                destination: 'lightbox',
                data: {
                    modelData: JSON.stringify(videos.toJSONForLightbox()),
                    indexToOpen: videos.indexOf(this.view.model),
                    variables: JSON.stringify(obj),
                    current_album: this.currentAlbum.toJSON(),
                    display_options: this.displayOptions.toJSON(),
                    usingKeyboard: ev.type === 'keydown'
                }
            };

            window.parent.postMessage(JSON.stringify(message), '*');

        },
        // Helper to format links with specific schemes like dynamic tracking tags
        formatLink: function(link, photo) {
            var displayOptions = this.displayOptions;

            if (!_.isFalsy(displayOptions.get('url_scheme')) || !_.isFalsy(gon.current_account.extra_fields.url_scheme)) {
                try {
                    var newLink = link;
                    var formatTitle = this.currentAlbum.get('title').replace(/ /g, '-').toLowerCase();
                    var albumTitle = encodeURIComponent(encodeURIComponent(formatTitle));
                    var urlScheme = displayOptions.get('url_scheme') ? displayOptions.get('url_scheme').url_scheme_title : gon.current_account.extra_fields.url_scheme.url_scheme_title;
                    var attributionString;

                    switch (urlScheme) {
                        case 'kimpton_gacid':
                            attributionString = '&gacid=' + window.PixleeTags.Kimpton.GACID;
                            break;
                        case 'kcp_pixlee':
                            attributionString = '&om=pixlee:' + albumTitle + ':' + this.currentAlbum.id;
                            break;
                        case 'kcp_pixlee_v2':
                            attributionString = '&pixlee=' + albumTitle + ':' + this.currentAlbum.id;
                            break;
                        default:
                            attributionString = displayOptions.get('url_scheme') ? displayOptions.get('url_scheme').attribution_string : gon.current_account.extra_fields.url_scheme.attribution_string;
                    }

                    //only append string once
                    if (newLink.indexOf(attributionString) !== -1) {
                        return newLink;
                    } else {
                        return newLink + attributionString;
                    }

                } catch (e) {
                    return link;
                }
            } else {
                return link;
            }
        }
    });

});
